module.exports = __webpack_public_path__ + "img/iphone.d718249e.png";